import Service from '@ember/service';
import config from 'sh-www/config/environment';
import { loadScript } from 'sh-www/utils/script-loader';

class StripeError extends Error {
  constructor({ code, message, type }) {
    super(message);
    this.code = code;
    this.type = type;
  }
}

export const isStripeError = (error) => {
  return error instanceof StripeError;
};

export const isStripeValidationError = (error) => {
  return isStripeError(error) && error.type === 'validation_error';
};

class StripeService extends Service {
  #stripePromise = null;
  #stripe = null;

  get stripe() {
    return this.#stripe;
  }

  load() {
    return this.#stripePromise ??= loadScript('https://js.stripe.com/v3/').then(() => {
      this.#stripe = Stripe(config.STRIPE.publishableKey);
    });
  }

  elements(options) {
    return this.#stripe.elements(options);
  }

  createToken(cardElement) {
    return this.#stripe.createToken(cardElement).then(({ token, error }) => {
      if (error) {
        throw new StripeError(error);
      } else {
        return token;
      }
    });
  }
}

export default StripeService;
